<template>
	<div id="createShow" v-on:click="onCreateShowClicked">
		<svg class="addBtn">
			<line x1="50" y1="0" x2="50" y2="100" stroke-width="2" />
			<line x1="0" y1="50" x2="100" y2="50" stroke-width="2" />
		</svg>
		<div class="title">Neue Präsentation erstellen</div>
	</div>
</template>

<script>
	export default {
		name: "CreateShowItem",
		props: ["createShow"],
		methods: {
			onCreateShowClicked() {
				console.log("create show");
				this.$router.push({path: '/create/'});
			}
		}
	}
</script>

<style scoped>
	#createShow {
		font-family: "BrownLLWeb-Regular";
		width: 250px;
		height: 250px;
		border: solid 2px black;
		background-color: white;
		color: black;
		margin-right: 25px;
		padding-left: 10px;
	}

	#createShow:hover {
		cursor: pointer;
		background-color: black;
		color: white;
	}

	.addBtn {
		height: 120px;
		margin-left: 55px;
		margin-top: 35px;
		stroke: black;
	}

	#createShow:hover .addBtn {
		stroke: white;
	}
	
	.title {
		font-size: 20px; /*25px;*/
		width: 230px;
		line-height: 1.2em;
		margin-top: 5px; /*0px;*/
		margin-bottom: 6px;
	}
</style>